// umlaut-check: skip — "begruendung" ist der Prop-/Feldname (technischer
// Bezeichner aus cosmos_vorschlaege.begruendung), bleibt ASCII.

import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {formatDatum, formatKw, formatMenge, herkunftText} from "./format.js";
import {TOOLTIP_POPPER_CONFIG} from "./tooltipConfig.js";

const FELD_LABEL = {
    bestand: "Bestand",
    offene_kundenmenge: "Offen, nicht reserviert (Planung)",
    basisverbrauch: "Basisverbrauch/Woche",
    reichweite_tage: "Reichweite",
    ausfallwoche: "Ausfallwoche",
    t_kritisch: "T kritisch",
    t_leer: "T leer",
    t_ideal: "T ideal",
    t_spaet: "T spät",
    mindestbestand: "Mindestbestand (M)",
    zielbestand: "Zielbestand (Z)",
    bereits_geplanter_zulauf: "Bereits geplanter Zulauf",
};

function wertText(schluessel, feld) {
    if (!feld || feld.wert === null || feld.wert === undefined) {
        return "–";
    }
    if (schluessel === "reichweite_tage") {
        return `${formatMenge(feld.wert)} Tage`;
    }
    if (schluessel === "ausfallwoche") {
        return formatKw(feld.wert);
    }
    if (["t_kritisch", "t_leer", "t_ideal", "t_spaet"].includes(schluessel)) {
        return formatDatum(feld.wert);
    }
    return formatMenge(feld.wert);
}

/**
 * Begründung eines Bestellvorschlags (Auftrag AP9 Punkt 3): eine kurze
 * Zeile direkt in der Tabelle, das vollständige Bild (jede Zahl mit
 * Herkunft/Sicherheit aus der Prognose) als Tooltip beim Überfahren -
 * keine Modal, keine zweite Seite nötig.
 */
export default function VorschlagBegruendung({begruendung}) {
    if (!begruendung) {
        return <span className="text-muted">–</span>;
    }

    const reichweite = begruendung.reichweite_tage?.wert;
    const bestand = begruendung.bestand?.wert;
    const kurzzeile =
        reichweite !== null && reichweite !== undefined
            ? `Reichweite ${reichweite} Tage, Bestand ${formatMenge(bestand)}`
            : `Bestand ${formatMenge(bestand)}`;

    const detail = (
        <div className="text-start" style={{maxWidth: 320}}>
            {Object.entries(FELD_LABEL).map(([schluessel, label]) => {
                const feld = begruendung[schluessel];
                if (!feld) {
                    return null;
                }
                const herkunft = herkunftText(feld);

                return (
                    <div key={schluessel} className="mb-1">
                        <span className="fw-semibold">{label}:</span> {wertText(schluessel, feld)}
                        {herkunft && <div className="small text-white-50">{herkunft}</div>}
                    </div>
                );
            })}
            {begruendung.warnung_zu_spaet?.wert && (
                <div className="mt-1 text-warning">
                    Warnung: zu spät{begruendung.warnung_zu_spaet.luecke_wochen ? ` – Lücke von ${begruendung.warnung_zu_spaet.luecke_wochen} Woche(n)` : ""}
                </div>
            )}
        </div>
    );

    return (
        <OverlayTrigger flip popperConfig={TOOLTIP_POPPER_CONFIG} placement="left" overlay={<Tooltip id="cosmos-vorschlag-begruendung">{detail}</Tooltip>}>
            <span tabIndex={0} className="small" style={{cursor: "help", borderBottom: "1px dotted"}}>
                {kurzzeile}
            </span>
        </OverlayTrigger>
    );
}
